<template>
    <div class="modal-card popia-modal">
        <header class="modal-card-head">
            <p class="modal-card-title">POPIA Agreement</p>
        </header>
        <section class="modal-card-body">
            <div>
                <p> We are obligated under POPIA to protect all users' personal information in accordance with 
                    the standards and norms set out in POPIA and the regulations promulgated thereto. For details 
                    on how we collect and process personal information, please refer to our Information Manual 
                    available at <a href="https://genexinstitute.com/" target="_blank" class="has-text-primary">https://genexinstitute.com/</a>
                </p> 
                <br/>
                <p>By accepting these terms and accessing the platform, you confirm, consent to and understand the following:</p>
                <div class="section">
                    <ol>
                        <li v-for="(item, index) in list_order" :key="index" class="mb-5"> {{ item }} </li>
                    </ol>
                    
                </div>
                <div class="has-text-warning is-justify-content-center is-flex">
                    <b-icon icon="alert-circle" class="mr-1"/>
                    <span>Please note if you decline, you will be redirected to the login page.</span>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot is-justify-content-center">
            <b-button class="button is-danger" @click="decline">Decline</b-button>
            <b-button class="button is-primary" @click="accept">Accept</b-button>
        </footer>
  </div>
</template>

<script>
import User from "@/models/lms/User";
import { format } from "date-fns";
import Store from "@/store";

export default {
    name: "POPIA",
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            list_order: [
                "You have read through our Information Manual and understand the purpose for which we collect and process personal information.",
                "You consent to the collection, processing and storage of your personal information on the Platform in line with legal requirements and the provisions of our Information Manual.",
                "The information collected from you is necessary for providing the Platform services we are offering.",
                "You have the right to access, correct, or request deletion of your personal information.",
                "To withdraw your consent, please submit a written request to the Information Officer listed in our Information Manual. Please note that withdrawing consent may affect our ability to provide services, although we may still be required to retain your information legally; and",
                "If you are a minor, you are being assisted by a competent adult when accepting these terms."
            ]
        }
    },
    methods: {
        decline() {
            this.$emit("close", false);
        },
        accept() {
            if (this.user) {
                Store.dispatch("loader/show");
                User.Update({
                    ...this.user,
                    accepted_popia_at: format(new Date(), "yyyy-MM-dd")
                }).then(() => {
                    Store.dispatch("toast/createToast", {
                        message: "Logged in successfully",
                        type: "is-success",
                    });
                    this.$emit("close", true);
                }).catch(err => {
                    this.handleError(err);
                    Store.dispatch("loader/hide");
                }) 
            }
        }
    },
    mounted() {
        Store.dispatch("loader/hide");
    }
}
</script>